import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';
import './Highlight.module.scss';

interface HighlightProps {
  editor: Editor;
}

export const Highlight: FunctionComponent<HighlightProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, canToggle } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('highlight'),
      canToggle: editor.can().chain().focus().toggleHighlight().run(),
    }),
  });

  return (
    <IconLabel
      iconId={'highlight'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-marker')}
      onClick={() => editor.chain().focus().toggleHighlight().run()}
      disabled={!canToggle}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: !canToggle,
      })}
    />
  );
};
